import { css } from '@emotion/react';
import { responsiveStyles } from '@polestar/component-warehouse-react/helpers/responsiveStyle';
import { shouldNotForwardThemeProps } from '@polestar/component-warehouse-react/helpers/shouldForwardProps';
import styled from '@emotion/styled';
import { createCSSTransition } from '@polestar/component-warehouse-react/tokens/motion/Motion';
import Orientations from '@polestar/component-warehouse-react/tokens/orientations/Orientations';
import Spacings from '@polestar/component-warehouse-react/tokens/spacings/Spacings';
import React, { forwardRef } from 'react';
const Spacer = forwardRef(({ spacing = Spacings.medium, orientation = Orientations.vertical, ...props }, ref) => React.createElement(Container, { ...props, ref: ref, spacing: spacing, orientation: orientation }));
Spacer.displayName = 'Spacer';
export default Spacer;
const Container = styled('div', shouldNotForwardThemeProps)(({ orientation, spacing, as }) => css(css `
    flex-shrink: 0;
    transition: ${createCSSTransition('width')}, ${createCSSTransition('height')};

    ${spacing !== undefined
    ? typeof spacing === 'string'
        ? `${orientation === Orientations.vertical ? 'height' : 'width'}: ${spacing};`
        : responsiveStyles({
            [orientation === Orientations.vertical ? 'height' : 'width']: spacing,
        })
    : ''}
    ${as === 'span' && `display: block;`}
  `));
